import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'getDate'
})
export class getDatePipe implements PipeTransform {

  transform(dateData: any, time: boolean = false, shortTime: boolean = false): any {
    if(!dateData) return "";
    if(shortTime)
        return moment(new Date(dateData)).format("DD MMM, YYYY HH:mm");
    else if(time)
        return moment(new Date(dateData)).format("DD MMM, YYYY hh:mm:ss A");
    else
        return moment(new Date(dateData)).format("DD MMM, YYYY");
  }

}
